<template>
    <!-- 理论考试题库 -->
    <div class="theoryQuestionBank">
        <el-row class="tableHearInputBox" type="flex" justify="space-between">
            <el-col>
                <el-input v-model.trim="query.query" placeholder="请输入试题名称" style="width: 200px; margin-right:10px"
                    @keyup.enter.native="freshLoad" @clear="
                        query.query = '';
                    freshLoad();
                    " clearable suffix-icon="el-icon-search"></el-input>
                <Debounce>
                    <el-button style="margin-right:10px" size="small" @click="freshLoad">查询</el-button>
                </Debounce>
                <el-select v-model="query.subjectId" style="margin-right:10px" @change="freshLoad" filterable
                    placeholder="请选择">
                    <el-option label="全部归属科目" :value="''"></el-option>
                    <el-option v-for="item in gsSubList" :key="item.subjectId" :label="item.name" :value="item.subjectId">
                    </el-option>
                </el-select>
                <el-select v-model="query.subjectLevel" style="margin-right:10px" @change="freshLoad" filterable
                    placeholder="请选择">
                    <el-option label="全部级别" :value="''"></el-option>
                    <el-option v-for="item in levelList" :key="item.subjectLevel" :label="item.subjectLevelName
                        " :value="item.subjectLevel">
                    </el-option>
                </el-select>
                <el-select v-model="query.type" style="margin-right:10px" @change="freshLoad" filterable placeholder="请选择">
                    <el-option label="全部归属部分" :value="''"></el-option>
                    <el-option v-for="item in typeSeleList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
            <el-button type="primary" size="small" @click="operatInfo(1)">添加</el-button>
            <FileDropDown @reLoad="freshLoad" style="margin:0px 10px;"
                :toUrl="['/basicQuestionsLibrary/export', '/basicQuestionsLibrary/import', '/basicQuestionsLibrary/importFile']"
                :theWay="[1, 2, 2]" :exportData="query" :isZip="true" :butText="['下载试题模板', '导入试题', '导入图片音频']" />
        </el-row>
        <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;"
            :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中"
            :height="$store.getters.getTableHeight">
            <el-table-column prop="questionsTh" label="题号" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="试题名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="subjectName" label="归属科目" align="center"></el-table-column>
            <el-table-column prop="subjectLevel" label="级别" align="center">
                <template slot-scope="scope">
                    {{ levelList.filter(item => { return item.subjectLevel == scope.row.subjectLevel })[0].subjectLevelName
                    }}
                </template>
            </el-table-column>
            <el-table-column prop="type" label="归属部分" align="center">
                <template slot-scope="scope">
                    {{ typeSeleList.filter(item => { return item.value == scope.row.type })[0].label }}
                </template>
            </el-table-column>
            <el-table-column prop="node" label="知识点类别" align="center"></el-table-column>
            <el-table-column prop="tx" label="题型" align="center">
                <template slot-scope="scope">
                    {{ scope.row.tx == 1 ? '单选题' : scope.row.tx == 2 ? '多选题' : scope.row.tx == 3 ? '填空多选题' : '音频题' }}
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <Debounce>
                        <el-button type="text" size="small" @click="operatInfo(2, scope.row)">查看
                        </el-button>
                    </Debounce>
                    <span style="margin:0px 10px;">|</span>
                    <Debounce>
                        <el-button class="tableContentRemoveBut" type="text" size="small"
                            @click="operatInfo(3, scope.row)">删除
                        </el-button>
                    </Debounce>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content"
            @pagination="tableLoad" />
    </div>
</template>
  
<script>
import FileDropDown from '@/views/admin/components/FileDropDown'

export default {
    components: {
        FileDropDown,
    },
    data() {
        return {
            tableList: [],
            tableIsLoad: true,
            query: {
                query: "",
                pageNum: 1, // 当前页
                pageSize: 15, // 每页显示条数
                total: 1, // 总条数
                subjectLevel: '', // 级别
                type: '', // 归属部分
                subjectId: '', // 归属科目
            },
            typeSeleList: [],
            gsSubList: [],
            stmcList: [],
            levelList: [],
            gsbfList: []
        };
    },
    mounted() {
        this.getSelects();
        this.tableLoad();
    },
    methods: {
        getSelects() {
            //归属科目下拉框
            this.$axios.get("/basicQuestionsLibrary/kemu").then((res) => {
                this.gsSubList = res.data.data
            });
            // 级别下拉框
            this.$axios.get("/basicQuestions/level").then((res) => {
                this.levelList = res.data.data
            });
            // 归属部分下拉框
            this.$axios.get("/basicQuestions/type").then((res) => {
                this.typeSeleList = res.data.data
            });
            // 科目级别级联下拉框
            this.$axios.get("/basicQuestions/subjectAndLevel").then((res) => {
                this.subjectList = res.data.data
            });
        },
        freshLoad() {
            this.query.pageNum = 1
            this.tableLoad()
        },
        tableLoad() {
            this.$axios.post("/basicQuestionsLibrary/list", this.query).then((res) => {
                console.log(res);
                let {
                    list,
                    total
                } = res.data.data;
                this.tableList = list;
                this.query.total = total;
                this.tableIsLoad = false;
            });
        },
        operatInfo(type, row) {
            if (type === 1) {
                this.$router.push({
                    path: '/information/theoryQuestionBank',
                    query: {
                        id: 2,
                        visiType: 1,
                    }
                })
            } else if (type === 2) {
                this.$router.push({
                    path: '/information/theoryQuestionBank',
                    query: {
                        id: 2,
                        visiType: 2,
                        row: JSON.stringify(row),
                    }
                })
            } else if (type === 3) {
                this.$dailog({
                    title: "删除",
                    context: "是否删除该试题？",
                    callbackFun: () => {
                        this.deleteTest(row);
                    },
                });
            }
        },
        // 删除试题
        deleteTest(row) {
            this.$axios({
                method: "delete",
                url: `/basicQuestionsLibrary/delete/${row.id}`,
            }).then((res) => {
                this.$message({
                    type: "success",
                    message: "删除试题成功!", duration: 1000
                });
                this.tableLoad()
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.iconDiv {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .changeIcon {
        width: 46%;
    }
}
</style>
<style lang="css"> .el-tooltip__popper {
     max-width: 50%
 }
</style>
  